export const profile = {
  profileFavoritesIconTitle: 'Обране',
  profileEditIconTitle: 'Редагувати',
  profileShareIconTitle: 'Поділитися',
  profileAdditionalSectionTitle: 'Додаткова інформація',
  profileFavoritesCurtainTitle: 'Обране',
  profileFavoriteActionTitle: 'В обране',
  profileFavoritedActionTitle: 'В обраному',
  profileMessageAction: 'Повідомлення',
  profileCurtainAdd: 'Додати',
  profileReportUser: 'Повідомити користувача',
  profileReportTitle: 'Повідомити',
  profileReportSuccess: 'Контент повідомлений',
  profileReset: 'Скинути',
  profileApply: 'Застосувати',
  profileCustomInvalidEmail: 'не є дійсною електронною адресою',
  profileMaxContentSizeError: 'Ви перевищили максимальний розмір контенту!',
  profileMaxAvatarSizeError: 'Розмір вашого аватара занадто великий!',
  profileFavoritesCurtainSearchInputText: 'Пошук',
  profileTapShareCurtainOptionTitle: 'Скопіювати',
  profileTapShareLinkCopiedAlertTitle: 'Посилання скопійовано!',
  profileQrShareCurtainTitle: 'Поділитися профілем',
  profileQrShareCurtainShareButtonTitle: 'Поділитися',
  profileQrShareCurtainCopyButtonTitle: 'Скопіювати',
  profileQrShareCurtainCopiedAlertTitle: 'Посилання скопійовано!',
  profileQrTapShareProfileCurtainTitle: 'Поділіться своїм профілем',
  profileEditTitle: 'Редагувати',
  profileEditPersonalSectionTitle: 'Особисті дані',
  profileEditContactsSectionTitle: 'Контакти',
  profileEditSocialSectionTitle: 'Соціальні мережі',
  profileEditAddSocialButtonTitle: 'Додати соціальні мережі',
  profileEditAdditionalSectionTitle: 'Додаткова інформація',
  profileEditSaveButtonTitle: 'Зберегти',
  profileEditSavedAlertTitle: 'Профіль збережено!',
  profileEditEmptyRequiredInputTitle: 'Поле не може бути порожнім',
  profileEditEmptyRequiredEmailInputTitle: 'Публічний електронний адрес не є дійсним',
  profileEditEmptyRequiredErrorTitle: 'Щось пішло не так!',
  profileEditSocialsHint: 'Будь ласка, введіть URL вашого соціального профілю',
  preferences: 'Уподобання',
  interestedIn: 'Зацікавлений у',
  expertIn: 'Я є експертом у',
  myPitch: 'Моя самопрезентація (Pitch)',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Я шукаю',
  topicsToDiscuss: 'Теми для обговорення',
  createNew: 'Створити',
  viewTopic: 'Переглянути',
  hobbyInterests: 'Хобі та інтереси',
  myNetwork: 'Моя мережа',
  seeAll: 'Переглянути все',
  checkThemOut: 'Перевірте їх!',
  activities: 'Активності',
  oneOnOne: '1:1 Зустріч',
  Leaderboard: 'Таблиця лідерів',
  learnNetworking: 'Дізнатися більше про Networking Hub',
  networkingGroup: 'Група для нетворкінгу',
  networkingLevel: 'Рівень нетворкінгу',
  addNote: 'Додати нотатку',
  notes: 'Нотатки',
  enterNote: 'Введіть нотатку',
  shareUserProfile: 'Поділитися профілем користувача',
  flagUser: 'Поскаржитися на користувача'
}
